import { FilterableMenuItem } from 'owa-filterable-menu';

export enum PreviewPaneCommandBarButton {
    Download,
    FullScreen, // Image
    Print, // Image, PDF
    ShowHideEmail,
}

export type PreviewPaneCommandBarItem = PreviewPaneCommandBarButton | FilterableMenuItem;

export function getDefaultPreviewPaneCommandBarItems(): PreviewPaneCommandBarItem[] {
    return [
        PreviewPaneCommandBarButton.Download,
        PreviewPaneCommandBarButton.FullScreen,
        PreviewPaneCommandBarButton.Print,
        PreviewPaneCommandBarButton.ShowHideEmail,
    ];
}

const styles = require('./commandBarItem.scss');
export function getHeroMenuItemClassName(): string {
    return styles.heroMenuItem;
}
